<template>
  <div class="Daerahxstrata">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>
    <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="item">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :href="goToRoute(item.href)"
          :disabled="item.disabled"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("daerahxstrata") }} {{ title }}
      </v-card-title>

      <v-container>
        <v-form ref="formdaerahxstrata">
          <v-row>
            <v-col cols="12" sm="4">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('negeri')"
                return-object
                :items="lookupnegeri"
                :item-text="item => item.negeriID +' - '+ item.negeri"
                item-value="negeriID"
                v-model="paparnegeriexport"
                :disabled="disablenegeri"
                v-on:change="paparlookupsample"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('sample')"
                return-object
                :items="lookupsample"
                item-text="sample"
                v-model="paparsample"
                ref="fokuspaparsample"
              ></v-autocomplete>
            </v-col>

               <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('pusingan')"
                return-object
                :items="lookuppusingan"
                item-text="pusingan"
                v-model="paparpusinganexport"
              ></v-autocomplete>
            </v-col>
            
            <v-col class="text-right">
             <v-btn
                    color="blue white white--text"
                    @click="cari()">
                    <span class="material-icons">search</span> 
                   {{ $t("cari") }}</v-btn> 
            </v-col>

            <Overlay v-show="showOverlay"/>

             <v-col v-show="isShowing" class="text-right">
                  <v-btn type="button" color="red white white--text" 
                @click="downloadPDF('pdf')"><span class='fas fa-file-pdf' style='font-size:24px'></span>
                {{ $t("muatturun") }} 
           </v-btn>
            &nbsp;&nbsp;

             <v-btn type="button" color="green white white--text"
                @click="downloadExcel('xls')"><span class='fas fa-file-excel' style='font-size:24px'></span>
                {{ $t("muatturun") }} 
              </v-btn></v-col></v-row>
              </v-form>

          <v-card-text>
          
         <v-simple-table ref="exportable_table" fixed-header dense class="table-bordered" id="table1">

          <thead>
              <tr>
                 <th colspan="1" style="text-align: center; border: none;">
                  <img src="https://i.ibb.co/WBrF5yQ/JATANEGARA.png" alt="JataNegara" width="80" height="70">
              </th>
              <th colspan="23" style="text-align: center; border: none;" class="text-h6">
                  <strong>SISTEM SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN ASAS  &nbsp;<br>
                  PENDAPATAN ISI RUMAH BULANAN MENGIKUT DAERAH PENTADBIRAN DAN STRATA</strong>
              </th>
             <th colspan="1" style="text-align: center; border: none;">
              <img src="https://i.ibb.co/bX8FgBj/HIES.png" alt="HIES/BA" width="80" height="70">
              </th>
            </tr>

              <tr>
              <th rowspan="3"  style="text-align:center;"><strong>DAERAH PENTADBIRAN</strong></th>
              <th colspan="6"  style="text-align:center;"><strong>2019</strong></th>
              <th colspan="6"  style="text-align:center;"><strong>2022 (TANPA WAJARAN)</strong></th>
              <th colspan="6" style="text-align:center;"><strong>2022 (BERWAJARAN)</strong></th>
              <th colspan="6"  style="text-align:center;"><strong>CAGR 2022</strong></th>
              </tr>
              <tr> 
              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>
              
              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>

              <th style="text-align:center;" ><strong>BANDAR</strong></th>
              <th style="text-align:center;" ><strong>LUAR BANDAR</strong></th>
              <th style="text-align:center;" ><strong>JUMLAH</strong></th>
              </tr>

              <tr>

              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Purata</strong></th>
              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Penengah</strong></th>

              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Purata</strong></th>
              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Penengah</strong></th>

              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Purata</strong></th>
              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Penengah</strong></th>

              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Purata</strong></th>
              <th colspan="3"  style="text-align:center;"><strong>Pendapatan Penengah</strong></th>

            </tr>

                
            </thead>
              
              <tbody>

              
                <tr>
                     <td style="text-align:left;"><strong> {{detailNegeri.negeri}}</strong></td>

                    <template v-for="item in dataz.data2019" >
                      <td v-if="item.Row == '1' && item.Col == '1' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.Value}} 
                      </td>
                    </template>

                    <template v-for="item in dataz.data2019" >
                      <td v-if="item.Row == '1' && item.Col == '2' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.Value}}        
                      </td>                    
                    </template>

                    <template v-for="item in dataz.data2019" >
                     <td v-if="item.Row == '1' && item.Col == '3' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                     </td>   
                    </template>

                    <template v-for="item in dataz.data2019" >
                     <td v-if="item.Row == '1' && item.Col == '4' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                     </td>
                    </template>

                    <template v-for="item in dataz.data2019" >
                      <td v-if="item.Row == '1' && item.Col == '5' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                      </td>
                    </template>

                    <template v-for="item in dataz.data2019" >
                      <td v-if="item.Row == '1' && item.Col == '6' && item.DP == ''" :key="item.index" style="text-align:center;">
                        {{item.Value}}
                      </td>
                    </template>

                     
                    <!-- //Tanpa Wajaran Purata-->
                     <td style="text-align:center;">
                          {{calculateJumlahBandarLuarBandar2022('1')}}
                     </td>
        
                    <td style="text-align:center;">
                          {{calculateJumlahBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                          {{calculateJpkasbJumlah()}}
                    </td>

                    <!-- //Tanpa Wajaran Penengah -->
                    <td style="text-align:center;">
                          {{calculateJumlahBandarLuarBandar2022Penengah('1')}}
                    </td>

                    <td style="text-align:center;">
                          {{calculateJumlahBandarLuarBandar2022Penengah('2')}}
                    </td>

                    <td style="text-align:center;">
                          {{calculateJPKASBJumlahPenengah()}}
                    </td>

                    <!-- //Wajaran Purata  -->
                    <td style="text-align:center;">
                          {{calculateWajaranJumlahBandarLuarBandar2022('1')}}
                     </td>
        
                    <td style="text-align:center;">
                          {{calculateWajaranJumlahBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                          {{calculateWajaranJpkasbJumlah()}}
                    </td>

                    <!-- Wajaran Penengah  -->
                    <td style="text-align:center;">
                          {{calculateWajaranPenengahJumlahBandarLuarBandar2022('1')}}
                     </td>
        
                    <td style="text-align:center;">
                          {{calculateWajaranPenengahJumlahBandarLuarBandar2022('2')}}
                    </td>

                    <td style="text-align:center;">
                          {{calculateJumlahPenengahBerwajaran()}}
                    </td>

                    <!-- CAGR 2022 PENDAPATAN PURATA  -->
                    <td style="text-align:center;">
                          {{calculateJumlahCAGR2022PendapatanPurata('Bandar')}}
                    </td>
        
                    <td style="text-align:center;">
                          {{calculateJumlahCAGR2022PendapatanPurata('LuarBandar')}}
                    </td>

                    <td style="text-align:center;">
                          {{calculateJumlahCAGR2022PendapatanPurata('Jumlah')}}
                    </td>

                    <!-- CAGR 2022 PENDAPATAN PENENGAH  -->
                    <td style="text-align:center;">
                          {{calculateJumlahCAGR2022PendapatanPenengah('Bandar')}}
                    </td>
        
                    <td style="text-align:center;">
                          {{calculateJumlahCAGR2022PendapatanPenengah('LuarBandar')}}
                    </td>

                    <td style="text-align:center;">
                          {{calculateJumlahCAGR2022PendapatanPenengah('Jumlah')}}
                    </td>

                </tr>

                <tr>
                <td colspan="25" style="text-align: left">
                  <strong>Daerah Pentadbiran :</strong>
                </td>
              </tr>

              <tr v-for="item in datazDaerah" :key="item.index">
                        <!-- ------loop getlistDaerah----  -->
                        <td style="text-align: left">{{item.NamaDP }}</td>
                       <!-- -------loop PURATA getlookup_daerahxstrata ------ -->
                      <td style="text-align:center;">{{DP(item.NamaDP,2019,1) }}</td>
                      <td style="text-align:center;">{{DP(item.NamaDP,2019,2) }}</td>
                      <td style="text-align:center;">{{DP(item.NamaDP,2019,3) }}</td>
                       <!-- -------loop PENGENGAH getlookup_daerahxstrata ------ -->
                      <td style="text-align:center;">{{DP(item.NamaDP,2019,4) }}</td>
                      <td style="text-align:center;">{{DP(item.NamaDP,2019,5) }}</td>
                      <td style="text-align:center;">{{DP(item.NamaDP,2019,6) }}</td>
                      <!-- ------PURATA TANPA WAJARAN 2022------- -->
                      <td style="text-align:center;">{{calculateJPKASBDaerahStrataPurata(item.DP,1) }}</td>
                      <td style="text-align:center;">{{calculateJPKASBDaerahStrataPurata(item.DP,2) }}</td>
                      <td style="text-align:center;">{{calculateJPKASBJumlahDaerahPurata(item.DP) }}</td>
                      <!-- ------PENENGAH TANPA WAJARAN 2022------- -->
                      <td style="text-align:center;">{{calculateJPKASBDaerahStrataPenengah(item.DP,1) }}</td>
                      <td style="text-align:center;">{{calculateJPKASBDaerahStrataPenengah(item.DP,2) }}</td>
                      <td style="text-align:center;">{{calculateJPKASBJumlahDaerahPenengah(item.DP) }}</td>
                      <!-- ------PURATA WAJARAN 2022------- -->
                      <td style="text-align:center;">{{calculateWajaranJPKASBDaerahStrataPurata(item.DP,1) }}</td>
                      <td style="text-align:center;">{{calculateWajaranJPKASBDaerahStrataPurata(item.DP,2) }}</td>
                      <td style="text-align:center;">{{calculateWajaranJPKASBJumlahDaerahPurata(item.DP) }}</td>
                      <!-- ------PENENGAH WAJARAN 2022------- -->
                      <td style="text-align:center;">{{calculateWajaranJPKASBDaerahStrataPenengah(item.DP,1) }}</td>
                      <td style="text-align:center;">{{calculateWajaranJPKASBDaerahStrataPenengah(item.DP,2) }}</td>
                      <td style="text-align:center;">{{calculateWajaranJPKASBJumlahDaerahPenengah(item.DP) }}</td>
                      <!-- ------PURATA CAGR % ------- -->
                      <td style="text-align:center;">{{calculateCAGR2022PurataDaerah(item.DP,1,1) }}</td>
                      <td style="text-align:center;">{{calculateCAGR2022PurataDaerah(item.DP,2,2) }}</td>
                      <td style="text-align:center;">{{calculateCAGR2022PurataJumlahDaerah(item.DP,3) }}</td>
                      <!-- ------PENENGAH CAGR % ------- -->
                      <td style="text-align:center;">{{calculateCAGR2022PenengahDaerah(item.DP,4,1) }}</td>
                      <td style="text-align:center;">{{calculateCAGR2022PenengahDaerah(item.DP,5,2) }}</td>
                      <td style="text-align:center;">{{calculateCAGR2022PenengahJumlahDaerah(item.DP,6) }}</td>



                                  
              </tr>
               
              </tbody>
            </v-simple-table>
          </v-card-text>
      </v-container>
    </v-card>
    </v-card>
  </div>
</template>
<script>
import Overlay from '../../components/Overlay'
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();

export default {
  components: {
   Overlay
 },
async beforeMount(){
   var res = await pusingan.getPusinganDataAll();
   this.lookuppusingan = res;

   this.lookupsample = await pusingan.getSample();
  
},
  Name: "Daerahxstrata",
  computed: {},
  setup() {},
  data: () => ({

    exportthn: "",
    exportbln: "",
    exportps: '',
    exportneg: '',
    snackbar: "",
    showOverlay: false,
   
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: `paparanutama`,
      },
      {
        text: 'Pendapatan Isi Rumah Bulanan Mengikut Daerah Pentadbiran Ketua Isi Rumah dan Strata',
        disabled: true,
        href: "",
      },
    ],
    title: "",
    lookupnegeri: [],
    sortedData:[],
    paparsample:"",
    paparpusinganexport: "",
    lookuppusingan: [],
    lookupsample: [],
    paparnegeri: "",
    paparnegeriexport: "",
    disablepusingan: true,
    peranan: "",
    disablenegeri: true,
    disablesample:true,
    data: [],
    dataz: [],
    detailNegeri:'',
    daerah: "",
    datazDaerah: [],
    datazlookupdaerahxstrata: [],
    dataJR2: [],
    isShowing:false,

    JumlahBandar2019: "",
    JumlahLuarBandar2019: "",
    JumlahJumlah2019: "",

  }),
  mounted() {
    this.$store.dispatch("localStorageuser");
    this.permulaan();
 
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}`;
    },

    downloadPDF: function () {
           
           var sTable = document.getElementById('table1').innerHTML;
     
     var style = "<style>";
     style = style + "body {font: 14px Calibri;}";
     style = style + "table {width: 100%; font: 12px Calibri;}";
     style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
     style = style + "padding: 2px 3px;text-align: center;}";
     style = style + "</style>";
     
     // CREATE A WINDOW OBJECT.
     var win = window.open( "http://www.domainname.ext/path.png",
                                  "DescriptiveWindowName");
     win.document.write('<html><head>');
     win.document.write('<title>Pendapatan Isi Rumah Bulanan Mengikut Daerah Pentadbiran Ketua Isi Rumah dan Strata</title>');   // <title> FOR PDF HEADER.
     win.document.write(style);          // ADD STYLE INSIDE THE HEAD TAG.
     win.document.write('</head>');
     win.document.write('<body>');
     
     win.document.write('<center>');
      win.document.write(`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Sample = `+this.paparsample.sample);
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     win.document.write('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
     
     win.document.write(`Pusingan = `+this.paparpusinganexport.pusingan);
     win.document.write('<br>');
     win.document.write('<br>');
     
     win.document.write(sTable);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
     win.document.write('</body></html>');
     
     win.document.close(); 	// CLOSE THE CURRENT WINDOW.
     win.setTimeout(function () {
     win.print();    // PRINT THE CONTENTS.
       }, 100)
     },

     downloadExcel: function () {
    //format xls
    var uri = 'data:application/vnd.ms-excel;base64,';
  
    var base64 = function(s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      },
      format = function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        })
      }
    var sTable = document.getElementById("table1").innerHTML;
    var ctx = {
      worksheet: 'PendapatanDaerah&Strata',
      table: sTable
    };
 
    var style = "<style>";
    style = style + "body {font: 12px Calibri;}";
    style = style + "table {width: 100%; font: 12px Calibri;}";
    style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
    style = style + "padding: 2px 3px;text-align: center;}";
    style = style + "</style>";

    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>PendapatanDaerah&Strata</x:Name>';

    tab_text = tab_text + '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    
    tab_text = tab_text + ('<center>');
    tab_text = tab_text + (`Negeri = `+this.detailNegeri.negeriID +' - '+this.detailNegeri.negeri);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (`Sample = `+this.paparsample.sample);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    
    tab_text = tab_text + (`Pusingan = `+this.paparpusinganexport.pusingan);
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');
    tab_text = tab_text + ('&nbsp;','&nbsp;','&nbsp;','&nbsp;','&nbsp;');

    tab_text = tab_text + (style); 
    tab_text = tab_text + (sTable);  

    tab_text = tab_text + '</body></html>';
   
    var link = document.createElement("a");
    link.download = "PendapatanDaerah&Strata.xls";
    link.href = uri + base64(format(tab_text, ctx))
    link.click();
 
    // window.location.href = uri + window.btoa(tab_text);
  
},

//      downloadExcel: function () {
//   var location = 'data:application/vnd.ms-excel;base64,';
// 	var excelTemplate = '<html> ' +
// 		'<head> ' +
// 		'<meta http-equiv="content-type" content="text/plain; charset=UTF-8"/> ' +
// 		'</head> ' +
// 		'<body> ' +
// 		document.getElementById("table1").innerHTML +
// 		'</body> ' +
// 		'</html>'
// 	window.location.href = location + window.btoa(excelTemplate);
// },

     async cari() {

      this.isShowing="true"
      this.showOverlay = true;
      this.findNegeri()
      this.TanpaWajaran2022()
      this.lookupDaerah()
      
    },

    // downloadExcel(type, fn, dl){
      
    //   var elt = this.$refs.exportable_table;
    //   var wb = XLSX.utils.table_to_book(elt, {sheet:"Sheet Js"});

    //   XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'})
    //   XLSX.writeFile(wb, fn || ('SheetJSTableExport.' + (type || 'xlsx')));

    // },
    
//Table lookup DaerahStrata 2019///////
    async Bandar2019() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getDaerahxStrata?NG=`+this.detailNegeri.negeriID,{
        });
        this.dataz = res.data.data2019;

      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

/// data pengiraan tahun semasa dari table JR2
    async TanpaWajaran2022() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getDaerahTanpaWajaran?NG=`+this.detailNegeri.negeriID+`&P=`+this.paparpusinganexport.id+`&S=`+this.paparsample.id,{
        });
        this.data = res.data.data;
        this.showOverlay = false;

        // this.jumlahjpksb1=this.calculateStrata('1')
        // this.jumlahjpksb2=this.calculateStrata('2')
      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

/// data lookup 2019
    async findNegeri() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getDaerahxStrata?NG=`+this.detailNegeri.negeriID,{
        });
        this.dataz = res.data.data;

        //console.log(this.dataz)

      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

// *********** 2022 (TANPA WAJARAN PURATA) ***********

      calculateJumlahBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalRespon = 0;

        for(var i = 0;i < arrLength ;i++){
          // //untuk st 1 = bandar /////////
          if (st == 1) {
              if (currData[i].ST == 1 || currData[i].ST == 2){
                totalRespon = totalRespon + 1;
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
          //untuk st 2 = luar bandar /////////
          if (st == 2) {
              if (currData[i].ST == 0 || currData[i].ST >= 3){
                // console.log("hang amsuk")
                totalRespon = totalRespon + 1;
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
        }

         var dataToReturn = Number(jpkasb)/ Number(totalRespon);

           if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
          
      },

      calculateJpkasbJumlah(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalRespon = arrLength;

        for(var i = 0;i < arrLength;i++){
              
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                }

        var dataToReturn = Number (jpkasb)/Number (totalRespon)

         if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }

      },

      calculateJPKASBDaerahStrataPurata(dp,st){
      var currData = this.data;
      var arrLength = currData.length;
      let jpkasbdaerah = 0;
      var totalRespon = 0;
      var dataToReturn =0;

      //kira JPKASB Daerah
      for(var i = 0;i < arrLength;i++){
            //console.log( currData[i].DP)
        if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
        }
        if (st == 1) {
              if ((currData[i].ST == 1 || currData[i].ST == 2) && currData[i].DP == dp){
                totalRespon = totalRespon + 1;
                jpkasbdaerah = jpkasbdaerah + Number( currData[i].JPKASB);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
          //untuk st 2 = luar bandar /////////
          if (st == 2) {
              if ((currData[i].ST == 0 || currData[i].ST >= 3) && currData[i].DP == dp){
                // console.log("hang amsuk")
                totalRespon = totalRespon + 1;
                jpkasbdaerah = jpkasbdaerah + Number( currData[i].JPKASB);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
        }
          dataToReturn = Number(jpkasbdaerah)/ Number(totalRespon);
           if(isNaN(dataToReturn)){
            return "-";
          }else{
            return Math.round(dataToReturn);
          }
    },

     calculateJPKASBJumlahDaerahPurata(dp){
        var currData = this.data;
        var arrLength = currData.length;
        let jumJPKASBDaerah = 0;
        var totalRespon = 0;

        for(var i = 0;i < arrLength;i++){
              if (currData[i].DP == dp){
                totalRespon = totalRespon + 1
                jumJPKASBDaerah = jumJPKASBDaerah + Number( currData[i].JPKASB);
                }
        }
        var dataToReturn = Number (jumJPKASBDaerah)/Number (totalRespon)
        if(isNaN(dataToReturn)){
            return "-";
          }else{
            return Math.round(dataToReturn);
          }

      },

    // *********** TAMAT 2022 (TANPA WAJARAN PURATA) ***********

    // ************ 2022 (TANPA WAJARAN PENENGAH) ***********

     calculateJumlahBandarLuarBandar2022Penengah(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalRespon = 0;
        var listjpksbuntukcarimin = [];
        var listjpksbuntukcarimin2 = [];

// ************ KIRA JPKASB PENENGAH STRATA) ***********
        for(var i = 0;i < arrLength ;i++){
          if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
              currData[i].JPKASB = 0;
          }
          if (st == 1) {
              if (currData[i].ST == 1 || currData[i].ST == 2){
                totalRespon = totalRespon + 1
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin.push(currData[i].JPKASB);
                }
          }
          if (st == 2) {
              if (currData[i].ST == 0 || currData[i].ST >= 3){
                totalRespon = totalRespon + 1
                jpkasb = jpkasb + Number( currData[i].JPKASB);
                //untuk cari min
                listjpksbuntukcarimin2.push(currData[i].JPKASB);
                }
          }
        }
     
        if (st == 1){
          // console.log("1")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin)
          
          }
        if (st == 2){
          // console.log("2")
          return  this.calculatemediankumulatif(listjpksbuntukcarimin2)
          

          }

      },

       calculatemediankumulatif(arrayjpkasb){
      // console.log(arrayjpkasb)
                var cubalagi = 0;
                var listkumulatif2 = [];

              if(arrayjpkasb.length < 1){
                  return dataToReturn = "-";
              }
              if(arrayjpkasb.length > 0){
                for(var y = 0;y < arrayjpkasb.length;y++){
                  cubalagi = cubalagi + 1/arrayjpkasb.length;
                  listkumulatif2.push(cubalagi)
                }
                  var medianFirst = 0;
                  var medianjpkasb = 0;
                  var half = 0;
                  arrayjpkasb.sort((a,b)=>a-b)
                  //console.log(arrayjpkasb)

                  half = Math.floor(listkumulatif2.length / 2);
                  // console.log("luar" + half)
                  //console.log("st1"  + listkumulatif2.length % 2)
                  if (listkumulatif2.length % 2 == 0)
                  { 
                   // console.log("genap" + half)
                    medianjpkasb = Number(arrayjpkasb[half - 1]);
                  }
                  else
                  {
                   //console.log("ganjil" + half)
                    medianjpkasb =  (Number(arrayjpkasb[half - 1]) + Number(arrayjpkasb[half])) / 2.0;
                  }
                  
                var dataToReturn = Number(medianjpkasb);
                //console.log(medianjpkasb)
                if(isNaN(dataToReturn)){
                  return "-";
                }else{
                  return Math.round(dataToReturn);
                }
              }
            
           },


      calculateJPKASBJumlahPenengah(){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasbjumwajaran = 0;
        var totalRespon = 0;
        var listjpksbuntukcariminJum = [];

        for(var i = 0;i < arrLength;i++){
                totalRespon = totalRespon + 1
                jpkasbjumwajaran = jpkasbjumwajaran + Number( currData[i].JPKASB);
                listjpksbuntukcariminJum.push(currData[i].JPKASB);
                // total = Number(penkasar.toFixed(2));
                }
       return  this.calculatemediankumulatif(listjpksbuntukcariminJum)
      },
  
      calculateJPKASBDaerahStrataPenengah(dp,st){
      var currData = this.data;
      var arrLength = currData.length;
      let jpkasbdaerahpenengah = 0;
      var totalRespon = 0;
      var listjpksbdaerahstratamin =[];
      var listjpksbdaerahstratamin2 =[];


      //kira JPKASB Daerah
      for(var i = 0;i < arrLength;i++){
            //console.log( currData[i].DP)
        if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
        }
        if (st == 1) {
              if ((currData[i].ST == 1 || currData[i].ST == 2) && currData[i].DP == dp){
                totalRespon = totalRespon + 1;
                jpkasbdaerahpenengah = jpkasbdaerahpenengah + Number( currData[i].JPKASB);
                 listjpksbdaerahstratamin.push(currData[i].JPKASB);

                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
          //untuk st 2 = luar bandar /////////
          if (st == 2) {
              if ((currData[i].ST == 0 || currData[i].ST >= 3) && currData[i].DP == dp){
                //  console.log("hang amsuk")
                totalRespon = totalRespon + 1;
                jpkasbdaerahpenengah = jpkasbdaerahpenengah + Number( currData[i].JPKASB);
                 listjpksbdaerahstratamin2.push(currData[i].JPKASB);

                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
        }

        if (st == 1){
          // console.log("1")
          return  this.calculatemediankumulatif(listjpksbdaerahstratamin)
          }
        if (st == 2){
          // console.log("2")
          return  this.calculatemediankumulatif(listjpksbdaerahstratamin2)
          }
    },

     calculateJPKASBJumlahDaerahPenengah(dp){
        var currData = this.data;
        var arrLength = currData.length;
        let jumJPKASBDaerah = 0;
        var totalRespon = 0;
        var listjpksbstratajumdaerah = [];

        for(var i = 0;i < arrLength;i++){
              if (currData[i].DP == dp){
                totalRespon = totalRespon + 1
                jumJPKASBDaerah = jumJPKASBDaerah + Number( currData[i].JPKASB);
                listjpksbstratajumdaerah.push(currData[i].JPKASB);
                }
        }

        return  this.calculatemediankumulatif(listjpksbstratajumdaerah)
            
      },

  // ************TAMAT 2022 (TANPA WAJARAN PENENGAH) *****************************


  //-----BERWAJARAN PURATA 2022------------------

      calculateWajaranJumlahBandarLuarBandar2022(st){
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var totalRespon = 0;

        for(var i = 0;i < arrLength ;i++){
          // //untuk st 1 = bandar /////////
          if (st == 1) {
              if (currData[i].ST == 1 || currData[i].ST == 2){
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
          //untuk st 2 = luar bandar /////////
          if (st == 2) {
              if (currData[i].ST == 0 || currData[i].ST >= 3){
                // console.log("hang amsuk")
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
        }

         var dataToReturn = Number(jpkasb)/ Number(totalWajaran);

           if(isNaN(dataToReturn)){
            return "-";
            }else{
            return Math.round(dataToReturn);
          }
          
      },

      calculateWajaranJpkasbJumlah(){
        var currData = this.data;
        var arrLength = currData.length;
        var jpkasb = 0;
        var totalWajaran = 0;
        var responwajaran = 0;
        //var totalHID = arrLength;

        for(var i = 0;i < arrLength ;i++){
                totalWajaran = totalWajaran + Number(currData[i].wajaran);
                jpkasb = jpkasb + Number(currData[i].JPKASB) * Number(currData[i].wajaran);
        }
                var dataToReturn = Number(jpkasb)/Number(totalWajaran);

                if(isNaN(dataToReturn)){
                  return "-";
                }else{
                    return Math.round(dataToReturn);
                }

      },

      calculateWajaranJPKASBDaerahStrataPurata(dp,st){
      var currData = this.data;
      var arrLength = currData.length;
      let jpkasbdaerah = 0;
      var totalRespon = 0;
      var dataToReturn =0;

      //kira JPKASB Daerah
      for(var i = 0;i < arrLength;i++){
            //console.log( currData[i].DP)
        if(currData[i].JPKASB == null || currData[i].JPKASB == ""){
            currData[i].JPKASB = 0;
        }
        if (st == 1) {
              if ((currData[i].ST == 1 || currData[i].ST == 2) && currData[i].DP == dp){
                totalRespon = totalRespon + 1;
                jpkasbdaerah = jpkasbdaerah + Number( currData[i].JPKASB);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
          //untuk st 2 = luar bandar /////////
          if (st == 2) {
              if ((currData[i].ST == 0 || currData[i].ST >= 3) && currData[i].DP == dp){
                // console.log("hang amsuk")
                totalRespon = totalRespon + 1;
                jpkasbdaerah = jpkasbdaerah + Number( currData[i].JPKASB);
                // total = Number(penkasartotalst.toFixed(2));
                //console.log(totalRespon)
                }
          }
        }
          dataToReturn = Number(jpkasbdaerah)/ Number(totalRespon);
           if(isNaN(dataToReturn)){
            return "-";
          }else{
            return Math.round(dataToReturn);
          }
    },

     calculateWajaranJPKASBJumlahDaerahPurata(dp){
        var currData = this.data;
        var arrLength = currData.length;
        let jumJPKASBDaerah = 0;
        var totalRespon = 0;

        for(var i = 0;i < arrLength;i++){
              if (currData[i].DP == dp){
                totalRespon = totalRespon + 1
                jumJPKASBDaerah = jumJPKASBDaerah + Number( currData[i].JPKASB);
                }
        }
        var dataToReturn = Number (jumJPKASBDaerah)/Number (totalRespon)
        if(isNaN(dataToReturn)){
            return "-";
          }else{
            return Math.round(dataToReturn);
          }

      },


  //-----TAMAT BERWAJARAN PURATA 2022------------------

  // ************************************ MULA JUMLAH 2022 (BERWAJARAN) PENDAPATAN PENENGAH *********************************

      calculatemediankumulatifWajaran(listjpksbuntukcarimin, arrayjpkasb){
      // console.log(arrayjpkasb)
              var kirakumulatif = 0;
              var dataToReturn = "-";
              var listkumulatif2 = [];
              
              if(arrayjpkasb.length < 1){
                  return dataToReturn = "-";
              }

              if(arrayjpkasb.length > 0){
                for(var j = 0;j < arrayjpkasb.length;j++){
                  if(listkumulatif2 == 0){
                    kirakumulatif = arrayjpkasb[j].nisbahWajaran
                    listkumulatif2.push(arrayjpkasb[j].nisbahWajaran)
                  }else{
                    kirakumulatif = kirakumulatif + arrayjpkasb[j].nisbahWajaran;
                    listkumulatif2.push(arrayjpkasb[j].nisbahWajaran)
                  }
                }
                console.log(listkumulatif2)
                  var medianFirst = 0;
                  var medianjpkasb = 0;
                  var half = 0;
                  listjpksbuntukcarimin.sort((a,b)=>a-b)
                  
                  half = Math.floor(listkumulatif2.length / 2);

                  if (listkumulatif2.length % 2 == 0)
                  { 
                    medianjpkasb = Number(listjpksbuntukcarimin[half - 1]);
                  }
                  else
                  {
                    medianjpkasb =  (Number(listjpksbuntukcarimin[half - 1]) + Number(listjpksbuntukcarimin[half])) / 2.0;
                  }
                console.log(medianjpkasb)
                dataToReturn = Number(medianjpkasb);
                if(isNaN(dataToReturn)){
                  return "-";
                }else{
                  return Math.round(dataToReturn);
                }
              }
           },
           
     calculateWajaranPenengahJumlahBandarLuarBandar2022(st){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              //if (currData[x].sts == 1 || currData[x].ST == 2){
              if (currData[x].sts == 1){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
                }
          }
          if (st == 2) {
              //if (currData[x].ST == 0 || currData[x].ST >= 3){
              if (currData[x].sts == 2){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
                }
          }
        }
       
        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              //if (currData[y].ST == 1 || currData[y].ST == 2){
              if (currData[y].sts == 1){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              //if (currData[y].ST == 0 || currData[y].ST >= 3){
              if (currData[y].sts == 2){

                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateJumlahPenengahBerwajaran(){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
        }
       
        for(var y = 0;y < arrLength ;y++){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)   
      },

    // ******************************* TAMAT JUMLAH 2022 (WAJARAN) PENDAPATAN PENENGAH *****************************

    // ************************************ MULA DAERAH 2022 (BERWAJARAN) PENDAPATAN PENENGAH *********************************
           
     calculateWajaranJPKASBDaerahStrataPenengah(dp,st){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
          if (st == 1) {
              //if (currData[x].sts == 1 || currData[x].ST == 2){
              if (currData[x].sts == 1 && currData[x].DP == dp){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
                }
          }
          if (st == 2) {
              //if (currData[x].ST == 0 || currData[x].ST >= 3){
              if (currData[x].sts == 2 && currData[x].DP == dp){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
                }
          }
        }
       
        for(var y = 0;y < arrLength ;y++){
          if (st == 1) {
              //if (currData[y].ST == 1 || currData[y].ST == 2){
              if (currData[y].sts == 1 && currData[y].DP == dp){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
          }
          if (st == 2) {
              //if (currData[y].ST == 0 || currData[y].ST >= 3){
              if (currData[y].sts == 2 && currData[y].DP == dp){

                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
              }
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)
      },

      calculateWajaranJPKASBJumlahDaerahPenengah(dp){
        
        var currData = this.data;
        var arrLength = currData.length;
        let jpkasb = 0;
        var totalWajaran = 0;
        var listjpksbuntukcarimin = [];
        var listdataWajaran = [];

        //kira JPKASB 
        // kira wajaran sahaja
        for(var x = 0;x < arrLength ;x++){
            if (currData[x].DP == dp){
                totalWajaran = totalWajaran + Number(currData[x].wajaran);
            }
        }
       
        for(var y = 0;y < arrLength ;y++){
            if (currData[y].DP == dp){
                currData[y].nisbahWajaran = Number(currData[y].wajaran) / Number(totalWajaran);
                listjpksbuntukcarimin.push(currData[y].JPKASB);
                listdataWajaran.push(currData[y]);
            }
          }
            return  this.calculatemediankumulatifWajaran(listjpksbuntukcarimin, listdataWajaran)   
      },

    // ******************************* TAMAT DAERAH 2022 (WAJARAN) PENDAPATAN PENENGAH *****************************
  
    // ******************************* MULA NEGERI CAGR 2022 PENDAPATAN PURATA  *****************************

        calculateJumlahCAGR2022PendapatanPurata(typeST){

          if(this.dataz != ''){
            var row = '';
            var col = '';
            var conBerwajaran = 0;

            // ***** Pendapatan Purata CAGR 2022 Jumlah
            if(typeST == 'Bandar'){
              row = "1"  
              col = "1"
              conBerwajaran = this.calculateWajaranJumlahBandarLuarBandar2022('1')
            }

            if(typeST == 'LuarBandar'){
              row = "1"  
              col = "2"
              conBerwajaran = this.calculateWajaranJumlahBandarLuarBandar2022('2')
            }

            if(typeST == 'Jumlah'){
              row = "1"  
              col = "3"
              conBerwajaran = this.calculateWajaranJpkasbJumlah('1','1')
            }

              var currData = this.dataz.data2019;
              var valuePurata = 0;
              
              for(var y = 0; y<currData.length; y++){
                if(this.dataz.data2019[y].Row == row && this.dataz.data2019[y].Col == col ){
                    valuePurata = this.dataz.data2019[y].Value
                }
              }

          }
        
          var totalPurata = Number(conBerwajaran) / Number(valuePurata)

          var data = Math.log(totalPurata)

          var dataToReturn = Number(data) / 0.03

          if(isNaN(dataToReturn)){
            return "-";
            }else{
            //return Math.log(dataToReturn);
            return dataToReturn.toFixed(1);
            }
        },

    // ******************************* TAMAT NEGERI CAGR 2022 PENDAPATAN PURATA  *****************************

    // ******************************* MULA NEGERI CAGR 2022 PENDAPATAN PENENGAH  *****************************

        calculateJumlahCAGR2022PendapatanPenengah(typeST){

          if(this.dataz != ''){
            var row = '';
            var col = '';
            var conBerwajaran = 0;

            // ***** Pendapatan Purata CAGR 2022 Jumlah
            if(typeST == 'Bandar'){
              row = "1"  
              col = "4"
              conBerwajaran = this.calculateWajaranPenengahJumlahBandarLuarBandar2022('1')
            }

            if(typeST == 'LuarBandar'){
              row = "1"  
              col = "5"
              conBerwajaran = this.calculateWajaranPenengahJumlahBandarLuarBandar2022('2')
            }

            if(typeST == 'Jumlah'){
              row = "1"  
              col = "6"
              conBerwajaran = this.calculateJumlahPenengahBerwajaran('1','1')
            }

              var currData = this.dataz.data2019;
              var valuePurata = 0;
              
              for(var y = 0; y<currData.length; y++){
                if(this.dataz.data2019[y].Row == row && this.dataz.data2019[y].Col == col ){
                    valuePurata = this.dataz.data2019[y].Value
                }
              }

          }
        
          var totalPurata = Number(conBerwajaran) / Number(valuePurata)

          var data = Math.log(totalPurata)

          var dataToReturn = Number(data) / 0.03

          if(isNaN(dataToReturn)){
            return "-";
            }else{
            //return Math.log(dataToReturn);
            return dataToReturn.toFixed(1);
            }
        },

    // ******************************* TAMAT NEGERI CAGR 2022 PENDAPATAN PENENGAH  *****************************

    // ------------------------------MULA PENDAPATAN PURATA CAGR 2022 DAERAH---------------------------------

        calculateCAGR2022PurataDaerah(Daerah,col,st){
        
          if(this.dataz != ''){

            let obj = this.dataz.data2019.find(o => o.DP == Daerah && o.Col == col);

            if (obj){
              var conBerwajaran = obj.Value;

              var WajaranDaerah = this.calculateWajaranJPKASBDaerahStrataPurata(Daerah,st)

              var removecomma = conBerwajaran.replace(/,/g, '')
              var totalPurata = Number(WajaranDaerah) / Number(conBerwajaran)
              var data = Math.log(totalPurata)
              var dataToReturn = Number(data) / 0.03

              if(isNaN(dataToReturn)){
              return "-";
              }else{
                return dataToReturn.toFixed(1);
              }
            }else{
                  return "-";
            }            
          }
        },

        calculateCAGR2022PurataJumlahDaerah(Daerah,col){
        
          if(this.dataz != ''){

            let obj = this.dataz.data2019.find(o => o.DP == Daerah && o.Col == col);

            if (obj){
              var conBerwajaran = obj.Value;

              var WajaranDaerah = this.calculateWajaranJPKASBJumlahDaerahPurata(Daerah)

              var removecomma = conBerwajaran.replace(/,/g, '')
              var totalPurata = Number(WajaranDaerah) / Number(conBerwajaran)
              var data = Math.log(totalPurata)
              var dataToReturn = Number(data) / 0.03

              if(isNaN(dataToReturn)){
              return "-";
              }else{
                return dataToReturn.toFixed(1);
              }
            }else{
                  return "-";
            }            
          }
        },
    // ...............................TAMAT PENDAPATAN PURATA CAGR 2022 DAERAH...............................

    // ------------------------------MULA PENDAPATAN PENENGAH CAGR 2022 DAERAH---------------------------------

        calculateCAGR2022PenengahDaerah(Daerah,col,st){
        
          if(this.dataz != ''){

            let obj = this.dataz.data2019.find(o => o.DP == Daerah && o.Col == col);

            if (obj){
              var conBerwajaran = obj.Value;

              var WajaranDaerah = this.calculateWajaranJPKASBDaerahStrataPenengah(Daerah,st)

              var removecomma = conBerwajaran.replace(/,/g, '')
              var totalPurata = Number(WajaranDaerah) / Number(conBerwajaran)
              var data = Math.log(totalPurata)
              var dataToReturn = Number(data) / 0.03

              if(isNaN(dataToReturn)){
              return "-";
              }else{
                return dataToReturn.toFixed(1);
              }
            }else{
                  return "-";
            }            
          }
        },

        calculateCAGR2022PenengahJumlahDaerah(Daerah,col){
        
          if(this.dataz != ''){

            let obj = this.dataz.data2019.find(o => o.DP == Daerah && o.Col == col);

            if (obj){
              var conBerwajaran = obj.Value;

              var WajaranDaerah = this.calculateWajaranJPKASBJumlahDaerahPenengah(Daerah)

              var removecomma = conBerwajaran.replace(/,/g, '')
              var totalPurata = Number(WajaranDaerah) / Number(conBerwajaran)
              var data = Math.log(totalPurata)
              var dataToReturn = Number(data) / 0.03

              if(isNaN(dataToReturn)){
              return "-";
              }else{
                return dataToReturn.toFixed(1);
              }
            }else{
                  return "-";
            }            
          }
        },
    // ...............................TAMAT PENDAPATAN PENENGAH CAGR 2022 DAERAH...............................

  async lookupDaerah() {
      try {
       const res = await axios.get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getListDaerahxStrata?NG=`+this.detailNegeri.negeriID,{ 
        });
      
        this.datazDaerah = res.data.data.listDaerah;
        this.datazlookupdaerahxstrata = res.data.data.datalookupdaerahxstrata;
            
        // console.log(this.datazDaerah)
      }
       catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

    DP(dp,tahun,c){
      var total = 0;
      let daerah = 0;
               
      for(var i = 0;i < this.datazlookupdaerahxstrata.length ;i++){
        // console.log(this.datalookupjadual[i])
          // if (this.datazlookupdaerahxstrata[i].NamaDP == dp && this.datazlookupdaerahxstrata[i].Tahun == tahun && this.datazlookupdaerahxstrata[i].ST == st ){
          if (this.datazlookupdaerahxstrata[i].NamaDP == dp && this.datazlookupdaerahxstrata[i].Col == c){
             return this.datazlookupdaerahxstrata[i].Value
         // this.daerah =  Number( currData[i].NamaDP);
          }
      }
    },

    async permulaan() {
      this.peranan = this.$store.state.localStorageuser.role;
      this.paparnegeriexport = this.$store.state.localStorageuser.kodneg;
      let negeri = await negerilookup.getNegeri();
      let role = ["PP", "PO", "FE", "RESPONDENT"]
      this.disablenegeri = role.includes(this.peranan) === true ? true : false;
      this.disablesample = role.includes(this.peranan) !== true ? true : false;
      const Negeri = [];
      negeri.data.data.forEach(async function (element) {
        if ((element.negeri !== "Admin") && (element.negeri !== "Responden")) {
          Negeri.push({
            negeriID: `${element.negeriID}`,
            negeri: `${element.negeri}`,
          });
        }
      });
      this.lookupnegeri = Negeri;
      
      for(var i =0;i<this.lookupnegeri.length;i++){
        if(this.lookupnegeri[i].negeriID == this.paparnegeriexport){
          this.detailNegeri = this.lookupnegeri[i];
        }
      }

    },

    async paparlookupsample(){
      
      this.negeri = this.paparnegeriexport.negeri; 
      this.disablesample = false;
      this.paparsample = "";
      this.paparpusinganexport = "";
      this.paparsampleexport();
    },

    paparNegeri(){
    
    if (this.Tahun === 2019){
      if (this.row === 1 && this.col === 2){
        this.NG16 = ""
      }
    }
      

      
    }
   
  },
  watch:{
    paparnegeriexport(val){ 
      this.detailNegeri = val; 
    },
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin: 50px auto;
}
/* tr {
  background: #eee;
} */

td,
th {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
  font-size: 18px;
}
</style>